var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "view" },
    [
      _c("v-card", { attrs: { "min-width": "300" } }, [
        _c(
          "div",
          {
            staticClass:
              "header navy darken-1 secondary--text pa-10 d-flex flex-column align-center",
          },
          [
            _c("img", {
              staticClass: "logo",
              attrs: { src: _vm.firebase_host + "/static/img/logo_ombra.png" },
            }),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "px-8 py-5 d-flex flex-column align-center" },
          [
            _c("h2", { staticClass: "mb-5" }, [_vm._v("Accesso Developer")]),
            _vm._v(" "),
            _vm.user_uid
              ? _c("div", [
                  _vm._v("\n        Al momento sei loggato: "),
                  _c("b", [_vm._v(_vm._s(_vm.user_uid))]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.Config.LOGIN_DEVELOPER
              ? _c(
                  "form",
                  {
                    attrs: { id: "form" },
                    on: {
                      submit: function ($event) {
                        $event.stopPropagation()
                        $event.preventDefault()
                        return _vm.login_developer.apply(null, arguments)
                      },
                    },
                  },
                  [
                    _c("v-text-field", {
                      attrs: {
                        label: "Username",
                        name: "username",
                        required: "",
                      },
                      model: {
                        value: _vm.username,
                        callback: function ($$v) {
                          _vm.username = $$v
                        },
                        expression: "username",
                      },
                    }),
                    _vm._v(" "),
                    _c("v-text-field", {
                      attrs: {
                        label: "Password",
                        name: "password",
                        required: "",
                        type: "password",
                      },
                      model: {
                        value: _vm.password,
                        callback: function ($$v) {
                          _vm.password = $$v
                        },
                        expression: "password",
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "v-btn",
                      {
                        staticClass: "pa-4 white--text",
                        attrs: {
                          depressed: "",
                          color: "secondary",
                          type: "submit",
                        },
                      },
                      [_vm._v("Login")]
                    ),
                  ],
                  1
                )
              : _c("div", [
                  _c("p", [_vm._v("Accesso developer non disponibile")]),
                ]),
          ]
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }